import { call, put, takeEvery } from "redux-saga/effects";
import { quyDinhSoTinChiApi } from "../../../api/dang-ky/quyDinhSoTinChiApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { IQuyDinhSoTinChi } from "../../../model/respone/lop-tin-chi/IQuyDinhSoTinChi";
import { eQuyDinhSoTinChiActionIds, IQuyDinhSoTinChiActionTypes } from "../../action-types/quan-ly-dang-ky/IQuyDinhSoTinChiActions";
import { rootActions } from "../../actions/rootActions";
import { IQuyDinhSoTinChiViewModel } from "../../../model/respone/lop-tin-chi/IQuyDinhSoTinChiViewModel";
import { lopTinChiApi } from "../../../api/lop-tin-chi/lopTinChiApi";

const mainAction = rootActions.quanLyDangKy.quyDinhSoTinChi;

export function* quyDinhSoTinChiSaga(): any {
    yield takeEvery(eQuyDinhSoTinChiActionIds.LOAD_START, loadWorker);
    yield takeEvery(eQuyDinhSoTinChiActionIds.SAVE_START, saveWorker);
    yield takeEvery(eQuyDinhSoTinChiActionIds.DELETE_START, deleteWorker);
    yield takeEvery(eQuyDinhSoTinChiActionIds.SUBMIT_START, submitWorker);
    yield takeEvery(eQuyDinhSoTinChiActionIds.LOAD_BY_HOC_KY_NAM_HOC_START, loadByHocKyNamHocWorker);

}

function* loadWorker(): any {
    const res: IBaseRespone = yield call(quyDinhSoTinChiApi.SelectAll);
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data));
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"));
    }
}

function* saveWorker(action: IQuyDinhSoTinChiActionTypes): any {
    let res: IBaseRespone;
    const quyDinh = action.payload as IQuyDinhSoTinChi;
    if (quyDinh.id_quy_dinh_dang_ky > 0) {
        res = yield call(quyDinhSoTinChiApi.Update, quyDinh);
    } else {
        res = yield call(quyDinhSoTinChiApi.Insert, quyDinh);
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(res.data));
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi"));
    }
}

function* deleteWorker(action: IQuyDinhSoTinChiActionTypes): any {
    const id = action.payload as number;
    const res: IBaseRespone = yield call(quyDinhSoTinChiApi.Delete, id);
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(res.data));
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi"));
    }
}

function* submitWorker(action: IQuyDinhSoTinChiActionTypes): any {
    const res: IBaseRespone = yield call(quyDinhSoTinChiApi.Submit, action.payload as IQuyDinhSoTinChiViewModel);
    if (res.is_success) {
        yield put(mainAction.SUBMIT_SUCCESS(undefined)); 
    } else {
        yield put(mainAction.SUBMIT_ERROR(res.message ?? "Có lỗi"));
    }
}

function* loadByHocKyNamHocWorker(action: IQuyDinhSoTinChiActionTypes): any {
    const { hocKy, namHoc } = action.payload as { hocKy: number, namHoc: string };
    const res: IBaseRespone = yield call(quyDinhSoTinChiApi.SelectByHocKyNamHoc, hocKy, namHoc);
    if (res.is_success) {
        yield put(mainAction.LOAD_BY_HOC_KY_NAM_HOC_SUCCESS(res.data));
    } else {
        yield put(mainAction.LOAD_BY_HOC_KY_NAM_HOC_ERROR(res.message ?? "Có lỗi"));
    }
}
